import { defineComponent } from '@ui/components/helpers';
import { componentBase } from '@ui/components/schemas';
import { s } from '@ui/validation';

export const icLoadingBarDefinition = defineComponent('ic-loading-bar', {
  base: componentBase,

  description:
    'Barra de progreso fija en el borde superior del marco que la contiene. Refleja el estado de FuseLoadingService: en modo automático se enciende con las peticiones HTTP que atraviesan el interceptor de Fuse.',

  props: {
    autoMode:
      s.boolean()
        .describe('Modo automático: la barra sigue las peticiones HTTP del interceptor. Con false solo responde a show/hide del servicio')
        .optional(),
  },

  defaults: {
    autoMode: true,
  },

  component: () =>
    import('./loading-bar.component').then(m => m.IcLoadingBarComponent),
});
